










import {Vue, Prop , Component, Emit} from 'vue-property-decorator';
@Component
export default class FileSelector extends Vue{
    onFileChanged(e: any){
        this.$emit('file-changed',e.target.files[0]);
    }
}
